import { ListItem, ListItemAvatar, ListItemText, Badge } from '@mui/material';
import { CadencePlayer } from '../types';

import { PlayerAvatar } from './PlayerAvatar';

type CadencePlayerItemProps = Readonly<{
  player: CadencePlayer;
  showAppearances?: boolean;
}>;

const colorMaps: Record<number, string> = {
  4: '#0d47a1',
  3: '#1565c0',
  2: '#42a5f5',
  1: '#90caf9',
};

export default function CadencePlayerItem({
  player,
  showAppearances = false,
}: CadencePlayerItemProps) {
  return (
    <ListItem
      sx={{ pl: 0 }}
      secondaryAction={
        <>
          {showAppearances && (
            <Badge
              badgeContent={player.appearances}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor:
                    colorMaps[player.appearances] || colorMaps[1],
                  color: 'white',
                },
              }}
            />
          )}
        </>
      }
    >
      <ListItemAvatar>
        <PlayerAvatar name={player.name} />
      </ListItemAvatar>
      <ListItemText primary={player.name} />
    </ListItem>
  );
}
